<template>
  <div>
    <div
      class="modal animated fadeIn"
      id="dailyexpensesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold">Daily expenses</small>
              </legend>
              <form @submit.prevent="loadDailyUpdates()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control from_date"
                        required
                      />
                    </div>
                  </div>
                   <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control end_date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button type="button" class="btn btn-danger btn-flat" data-dismiss="modal">
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button type="submit" class="btn btn-primary btn-flat DailyUpdate">
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat DailyUpdateLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
   
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage file opened</small>
      </legend>
      <button
        type="button"
        class="btn btn-primary btn-roundec"
        data-toggle="modal"
        data-target="#dailyexpensesModal"
      >
        <i class="fa fa-file-pdf-o"></i> Daily updates
      </button>
       <p></p>
      <div></div>
      <div class="fileopeningsLoader">
        <span class="spinner-border text-primary spinner-border-sm" role="status" aria-hidden="true"></span>
        <span style="font-sixe: 14px;"></span>loading files...
      </div>
      <vue-good-table
        :columns="columns"
        :rows="systemFileopenings"
        :fixed-header="true"
        :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'Action'">
            <button
              v-b-tooltip.hover.bottom="'Edit file!'"
              class="btn btn-primary btn-sm btn-rounded"
              @click="viewFileopening(props.row.id)"
            >
              <i class="fa fa-edit"></i> Edit fileopening
            </button>
          </span>

          <span v-else-if="props.column.field === 'Cargo'">
            <button
              v-b-tooltip.hover.bottom="'Add cargo!'"
              class="btn btn-primary btn-sm btn-rounded"
              @click="fileCargo(props.row.id)"
            >
              <i class="fa fa-plus"></i> Add cargo
            </button>
          </span>
        </template>
      </vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "File code",
          field: "file_code",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by file code"
          }
        },
        {
          label: "File ref",
          field: "file_ref",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by file ref"
          }
        },
        {
          label: "Customer name",
          field: "customer_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter customer"
          }
        },
        {
          label: "Opened Date",
          field: "opened_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy" // outputs Mar 16th 2018
        },
        {
          label: "Bill of landing",
          field: "bill_landing",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by bol"
          }
        },
        {
          label: "Goods description",
          field: "description",
          type: "text"
        },
        {
          label: "Submitted by",
          field: "fullname",
          type: "text"
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true
        },
        {
          label: "Add cargo",
          field: "Cargo",
          width: "122px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadFileopenings();
  },
  computed: {
    ...mapGetters(["systemFileopenings"])
  },
  methods: {
    ...mapActions([
      "loadFileopenings",
      "viewFileopening",
      "fileCargo",
      "loadDailyUpdates"
    ])
  }
};
</script>
<style scoped>
.DailyUpdateLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/fileopenings/managefileopenings.vue